import React, { useState, useEffect } from "react";
import "./ReportTableRow.css";
import NoteModal from "./NoteModal";
import { updateStudent } from "../services/APIClient";
import Switch from "react-switch";
import { Tooltip } from "react-tooltip";

const IMAGE_PATH = process.env.PUBLIC_URL + "/assets/imgs/";

function HandoverTableRow({
  student,
  dummyHeaderArray,
  getReadingScoreClass,
  handleShowReadingScoreModal,
  handleShowLiteracyModal,
  handleShowAdditionalNeedsModal,
  handleShowSupportPlanModal,
  handleShowEalModal,
  handleShowSetModal,
  handleShowAttendanceAffectingScoresModal,
  handleShowConfirmationModalEAL,
  handleShowConfirmationModalSET,
  handleShowConfirmationModalAttendance,
  setSaveClicked,
  teacherid,
  classId,
  setSortedData,
  sortStudents,
  sortCriteria,
  additionalRoles,
  saveClicked,
  teachers,
  getReport,
  upsertReport,
  onSenToggle,
  watchlistStatuses,
  noteType = "ClassroomHandover",
  ealManagedByReport = false,
}) {
  const [readingScoreNotes, setReadingScoreNotes] = useState([]);
  const [literacyObservations, setLiteracyObservations] = useState("");
  const [additionalNeeds, setAdditionalNeeds] = useState([]);
  const [supportPlan, setSupportPlan] = useState([]);
  const [eal, setEal] = useState(false);
  const [set, setSet] = useState(false);
  const [attendanceAffectingScores, setAttendanceAffectingScores] = useState(false);
  const [currentStudentId, setCurrentStudentId] = useState("");
  const assessmentScores = student.assessmentScores || { baseline: null, midpoint: null, endOfYear: null };

  const userIsSencoOrSet = () => {
    if (!additionalRoles || !Array.isArray(additionalRoles)) return false;
    return additionalRoles.some(
      (role) =>
        typeof role === "string" &&
        (role.toUpperCase() === "SENCO" || role.toUpperCase() === "SET" || role === "Special Educator/SET")
    );
  };

  useEffect(() => {
    console.log(currentStudentId);
  }, [currentStudentId]);

  useEffect(() => {
    console.log("HandoverTableRow: saveClicked changed to:", saveClicked);
  }, [saveClicked]);

  useEffect(() => {
    if (student.id) {
      getReport(student.id)
        .then((response) => {
          if (response) {
            setReadingScoreNotes(response.readingscorenotes || []);
            setLiteracyObservations(response.literacyobservations || "");
            setAdditionalNeeds(response.additionalneeds || []);
            setSupportPlan(response.supportplan || []);
            setEal(response.eal !== undefined ? response.eal : student.esl || false);
            setSet(response.set || false);
            setAttendanceAffectingScores(response.attendanceaffectingscores || false);
          } else {
            setEal(student.esl || false);
            setReadingScoreNotes([]);
            setLiteracyObservations("");
            setAdditionalNeeds([]);
            setSupportPlan([]);
            setSet(false);
            setAttendanceAffectingScores(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching report:", error);
          setEal(student.esl || false);
        });
    }
  }, [student.id, student.esl, saveClicked, getReport]);

  useEffect(() => {
    const saveReport = () => {
      if (currentStudentId) {
        const reportData = {
          studentid: currentStudentId,
          teacherid: teacherid,
          set: set,
          attendanceaffectingscores: attendanceAffectingScores,
        };
        upsertReport(reportData)
          .then((response) => {
            console.log("Upsert Report Success (SET/Attendance):", response);
          })
          .catch((error) => console.error("Error:", error));
      }
    };
    if (currentStudentId) {
      saveReport();
    }
  }, [set, attendanceAffectingScores, currentStudentId, teacherid, upsertReport]);

  // Render score display
  const renderAssessmentScore = (score) => {
    if (score === null || score === undefined || score === "No completed tasks" || score === "No assessments") {
      return <span className="reading-score">NYS</span>;
    }

    if (typeof score === 'number') {
      return (
        <span className={`reading-score ${getReadingScoreClass(score)}`}>
          {score}%
        </span>
      );
    }

    return <span className="reading-score">{score}</span>;
  };

  const handleEalToggle = async (studentId, currentEalValue) => {
    const newEalValue = !currentEalValue;
    setEal(newEalValue);
    try {
      await upsertReport({ studentid: studentId, teacherid, eal: newEalValue });
      if (!ealManagedByReport) {
        await updateStudent(studentId, { esl: newEalValue });
      }
    } catch (error) {
      console.error("Error updating EAL/ESL state:", error);
      setEal(currentEalValue);
    }
  };


  return (
    <>
      <tr
        key={student.id}
        className="table-row student-results-table-row"
        data-student-id={student.id}
      >
        <td className="centre-student-items align-left">{student.name}</td>
        <td className="centre-student-items">
          <NoteModal
            entityName={student.name}
            elementtype="student"
            elementid={student.id}
            noteType={noteType}
            filterByNoteType={noteType === "ClassroomObservation"}
            teacherid={teacherid}
            teachers={teachers || []}
          />
        </td>
        {/* <td className="centre-student-items task-badge-parent tooltip-container">
          {student.readingScore !== undefined && student.readingScore !== null ? (
            student.readingScore === "No completed tasks" ? (
              <span className="reading-score">{student.readingScore}</span>
            ) : (
              <span className={`reading-score ${getReadingScoreClass(student.readingScore)}`}>
                {student.readingScore}%
              </span>
            )
          ) : null}
          <span className="tooltip">Average of all this years screening points</span>
        </td> */}
        <td className="centre-student-items task-badge-parent tooltip-container score-individual-cell" style={{ width: '50px'}}>
          {renderAssessmentScore(assessmentScores.baseline)}
        </td>
        <td className="centre-student-items task-badge-parent tooltip-container score-individual-cell" style={{ width: '50px' }}>
          {renderAssessmentScore(assessmentScores.midpoint)}
        </td>
        <td className="centre-student-items task-badge-parent tooltip-container score-individual-cell" style={{ width: '50px'}}>
          {renderAssessmentScore(assessmentScores.endOfYear)}
        </td>
        {dummyHeaderArray.map((header, index) => (
          <td key={index} className="centre-student-items">
            {header === "Overall Score Observations" ? (
              <img
                src={readingScoreNotes.length > 0 ? `${IMAGE_PATH}file-pen-outline.svg` : `${IMAGE_PATH}file-outline.svg`}
                alt="Icon"
                style={{ cursor: "pointer" }}
                onClick={() => handleShowReadingScoreModal(student.name, student.id)}
              />
            ) : header === "Literacy Observations" ? (
              <img
                src={literacyObservations && literacyObservations.length > 0 ? `${IMAGE_PATH}file-pen-outline.svg` : `${IMAGE_PATH}file-outline.svg`}
                alt="Icon"
                style={{ cursor: "pointer" }}
                onClick={() => handleShowLiteracyModal(student.name, student.id)}
              />
            ) : header === "AEN Observations" ? (
              <img
                src={additionalNeeds.length > 0 ? `${IMAGE_PATH}file-pen-outline.svg` : `${IMAGE_PATH}file-outline.svg`}
                alt="Icon"
                style={{ cursor: "pointer" }}
                onClick={() => handleShowAdditionalNeedsModal(student.name, student.id)}
              />
            ) : header === "Classroom Support Observations" ? (
              <img
                src={supportPlan.length > 0 ? `${IMAGE_PATH}file-pen-outline.svg` : `${IMAGE_PATH}file-outline.svg`}
                alt="Icon"
                style={{ cursor: "pointer" }}
                onClick={() => handleShowSupportPlanModal(student.name, student.id)}
              />
            ) : header === "EAL" ? (
              <label style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                <input
                  type="checkbox"
                  checked={eal}
                  onChange={() => handleEalToggle(student.id, eal)}
                  style={{ appearance: "none", width: "20px", height: "20px", borderRadius: "50%", border: "2px solid #2c7693", backgroundColor: "white", cursor: "pointer" }}
                />
                {eal && (
                  <img src={`${IMAGE_PATH}greenTick.svg`} alt="Checked" style={{ width: "15px", position: "absolute" }} />
                )}
              </label>
            ) : header === "Watchlist" ? (
              <>
                <div style={{ display: "inline-block", position: "relative" }}>
                  <div style={{ display: "inline-block", position: "relative" }} className="switch-container">
                    <Switch
                      onChange={() => {
                        const isOnWatchlist = watchlistStatuses?.[student.id];
                        if (!isOnWatchlist || userIsSencoOrSet()) {
                          onSenToggle(student.id, isOnWatchlist);
                        }
                      }}
                      checked={!!watchlistStatuses?.[student.id]}
                      height={20}
                      width={40}
                      onColor="#1A56DB"
                      offColor="#88888899"
                      activeBoxShadow="0 0 2px 3px #1A56DB"
                      handleDiameter={18}
                      disabled={watchlistStatuses?.[student.id] && !userIsSencoOrSet()}
                    />
                    {watchlistStatuses?.[student.id] ? (
                      <span className="tooltip">
                        {userIsSencoOrSet()
                          ? "Click to remove the child from the watchlist"
                          : "only a SET or SENCO can remove the child from the watchlist"}
                      </span>
                    ) : (
                      <span className="tooltip">If concerned, add child to the watchlist to discuss with SEN Team.</span>
                    )}
                  </div>
                </div>
              </>
            ) : header === "Attendance Affecting Scores" ? (
              <label style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                <input
                  type="checkbox"
                  checked={attendanceAffectingScores}
                  onChange={() => {
                    setCurrentStudentId(student.id);
                    setAttendanceAffectingScores((prev) => !prev);
                  }}
                  style={{ appearance: "none", width: "20px", height: "20px", borderRadius: "50%", border: "2px solid #2c7693", backgroundColor: "white", cursor: "pointer" }}
                />
                {attendanceAffectingScores && (
                  <img src={`${IMAGE_PATH}greenTick.svg`} alt="Checked" style={{ width: "15px", position: "absolute" }} />
                )}
              </label>
            ) : (
              <button className="white-button">
                <i className="bi bi-pencil-square"></i>
              </button>
            )}
          </td>
        ))}
      </tr>
      <Tooltip id="show-as-tooltip" place="top" />
    </>
  );
}

export default React.memo(HandoverTableRow);
